import { TradingViewTimeframesEnum } from '@modules/trading-view-module/enums/trading-view-timeframes.enum'

export const MinutesTimeframes: TradingViewTimeframesEnum[] = [
	TradingViewTimeframesEnum.oneMinute,
	TradingViewTimeframesEnum.threeMinutes,
	TradingViewTimeframesEnum.fiveMinutes,
	TradingViewTimeframesEnum.fifteenMinutes,
	TradingViewTimeframesEnum.thirtyMinutes,
]
